import "babel-polyfill";
import Vue from 'vue'
import axios from 'axios'
import landingdashboard from './landingdashboard.vue'
// import landingfaq from './landingfaq.vue'
import landingUser from './landingUser.vue'
//import landingNotice from './landingNotice.vue'
import raintoy from './raintoy/raintoy.vue';

Vue.prototype.$http = axios;

// new Vue({
//     el: '#dashboard',
//     render: h => h(landingdashboard)
// });

new Vue({
    el: '#landingUser',
    render: h => h(landingUser)
});

// new Vue({
//     el: '#landingfaq',
//     render: h => h(landingfaq)
// });

//new Vue({
//    el: '#landingNotice',
//    render: h => h(landingNotice)
//})

new Vue({
    el: '#raintoy',
    render: h => h(raintoy)
});


// WEBPACK FOOTER //
// ./src/main.js